import { cloneDeep } from 'lodash'
import { randstr } from '../../lib/Tools'
import createDuck from '../lib/MetagnosticDuck'
import ActionTypes from '../actions/ActionTypes.js'
import { getBlock, getBlocks } from '../lib/APIClient'
import { cloneRoute, createRoute } from './routes'

/**
 * empty block
 */

const emptyBlock = {
  _id: null,
  city: "",
  days: 1,
  subtitle: "",
  note: "",
  name: "", 
  title: "",
  description: "",
  entries: [], 
  template: true, 
  files: { 
    doc1dayBg: null, 
    doc1Page: null 
  }, 
  route: null 
}

/**
 * Creation actions 
 */

const getId = ({ name }) => encodeURIComponent(
  (name ? name.replace(/España|en|días| |ñ/g, "") : randstr(9)) + randstr(9))

const justTheBlock = (initials, cb, dispatch) => {
  const id = getId(initials)
  if (cb) cb(id)
  dispatch({
    type: ActionTypes.CREATE_ONE_BLOCKS,
    id, 
    payload: initials
  })
}

const _createBlock = (initials, cb) => dispatch => {
  if (!initials.name) throw "Must specify new block's name"

  dispatch(
    createRoute({}, route => {
      console.log(`route created, ${route}`)
      justTheBlock({ ...initials, route }, cb || null, dispatch)
    }))
}

const _createBlockFromRoute = (initials, cb, route) => dispatch => {
  if (!initials.name) throw "Must specify new block's name"

  dispatch(
    cloneRoute(route, newRoute => {
      justTheBlock({ ...initials, route: newRoute }, cb || null, dispatch)
    }))
}

const _createBlockFromAgenda = (initials, cb, agenda) => dispatch => {
  if (!initials.name) throw "Must specify new block's name"

  dispatch(
    createRoute({ agenda }, route => {
      justTheBlock({ ...initials, route }, cb || null, dispatch)
    }))
}

/**
 * 
 */

const duck = createDuck(
  /* name, getDoc, getCollection,  */
  "BLOCKS", 
  getBlock, 
  getBlocks, 
  /* customActions,  */
  {
    getId,
    createDoc: _createBlock, 
    createBlockFromRoute: _createBlockFromRoute, 
    createBlockFromAgenda: _createBlockFromAgenda, 
  }, 
  /* emptyDoc,  */
  emptyBlock, 
  /* customReducers = {},  */
  {}, 
  /* extra options */
  {}
)

export const createBlock = duck.actions.createDoc
export const receiveBlocks = duck.actions.receiveCollection
export const receiveBlock = duck.actions.receiveDoc
export const removeBlock = duck.actions.removeDoc
export const fetchBlocks = duck.actions.fetchCollection
export const updateBlock = duck.actions.updateDoc
  
export const createBlockFromRoute = duck.actions.createBlockFromRoute
export const createBlockFromAgenda = duck.actions.createBlockFromAgenda

export default duck
